// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-icon {
  height: 24px;
  width: 24px;
  fill: currentColor;
  transition: color 0.3s;
  outline: none;
}
.svg-icon.icon-xs {
    height: 10px;
    width: 10px;
}
.svg-icon.icon-sm {
    height: 12px;
    width: 12px;
}
.svg-icon.icon-md {
    height: 16px;
    width: 16px;
}
.svg-icon.icon-lg {
    height: 20px;
    width: 20px;
}
.svg-icon.icon-xl {
    height: 24px;
    width: 24px;
}
.svg-icon.icon-2xl {
    height: 28px;
    width: 28px;
}
.svg-icon.icon-3xl {
    height: 32px;
    width: 32px;
}
.svg-icon.icon-4xl {
    height: 36px;
    width: 36px;
}
.svg-icon.icon-5xl {
    height: 40px;
    width: 40px;
}
.svg-icon.icon-6xl {
    height: 50px;
    width: 50px;
}
.svg-icon.icon-7xl {
    height: 64px;
    width: 64px;
}
.svg-icon.icon-7-5xl {
    height: 82px;
    width: 82px;
}
.svg-icon.icon-8xl {
    height: 128px;
    width: 128px;
}
.svg-icon.icon-9xl {
    height: 256px;
    width: 256px;
}
.svg-icon.icon-10xl {
    height: 320px;
    width: 320px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
